import type { IconData } from '@stacksjs/iconify-core'

export const door: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 0h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m0 2v16h8V2zm2 7h1a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default door
